import axios from "axios";
import HomePage from "../types/home-page";
import { getRegionId, getToken } from "../lib/middleware";

export async function getHomePage() {
    try {
        const token = getToken();
        const regionId = getRegionId();

        const headers: Record<string, string> = {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
        };
        // Only default region-id to 190 for UAE when the user isn't logged in yet or doesn't already have a region-id set.
        if (!token || !regionId) {
            headers["region-id"] = "190";
        }
        const response = await axios.get("/home", {
            headers,
        });
        const data = response.data;

        return data.data as HomePage;
    } catch (error) {
        console.error(error);
    }
}
